import { Button, Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import styled from 'styled-components';
import { BLUE_COLOR } from '../../../../../constants/ColorsConst';
import * as CONST from '../../../../../constants/FieldsConst';
import { textLabels } from '../../../../../helpers';
import { LoadingWidget, ModalComponent } from '../../../../../widgets';
import ActionsListWidget from '../../../../../widgets/ActionsList';
import { NameComponent } from '../../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allPagosSuscripcionAction,
  deletePagosSuscripcionAction,
  setActivoPagosSuscripcionAction,
} from '../PagosSuscripcionAction';
import { PARAMS_PAGOS_SUSCRIPCION } from '../PagosSuscripcionReducer';

export const Links = styled.a`
  cursor: pointer;
  color: black;
  margin: 0px 0px;
  text-decoration: none;

  &:hover {
    color: blue;
  }
`;

const ListadoPagosSuscripcion = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();

  const loginStore = Redux.useSelector((state) => state.login);
  const suscripcionesStore = Redux.useSelector((state) => state.suscripciones);
  const pagosSuscripcionStore = Redux.useSelector(
    (state) => state.pagosSuscripcion,
  );

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  React.useEffect(() => {
    const payload = {
      ...pagosSuscripcionStore.params,
      idSuscripcion: suscripcionesStore.activo.id,
    };
    dispatch({ type: PARAMS_PAGOS_SUSCRIPCION, payload });
    if (pagosSuscripcionStore.all && pagosSuscripcionStore.all.length === 0) {
      allPagosSuscripcionAction(dispatch, payload);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handleEditClick = async (id) => {
    const data = pagosSuscripcionStore.all.find((el) => el.id === id);
    await setActivoPagosSuscripcionAction(dispatch, data);
    setOpenModalForm(true);
  };

  const _handleDeleteClick = async (id) => {
    await deletePagosSuscripcionAction(
      dispatch,
      id,
      pagosSuscripcionStore.params,
      setLoadingDelete,
    );
    setOpenModalDelete(false);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.entidad.name,
      label: CONST.entidad.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <NameComponent
                onClick={() => _handleEditClick(tableMeta.rowData[0])}
              >
                {value.nombre}
              </NameComponent>
              <Typography variant="body1" color="initial">
                {value.correo}
              </Typography>
            </>
          );
        },
      },
    },
    {
      name: CONST.titular.name,
      label: CONST.titular.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <NameComponent
                onClick={() => _handleEditClick(tableMeta.rowData[0])}
              >
                {value.perfil.pnombre} {value.perfil.papellido}
              </NameComponent>
              <Typography variant="body1" color="initial">
                {value.correo}
              </Typography>
            </>
          );
        },
      },
    },
    {
      name: CONST.fechaInicio.name,
      label: CONST.fechaInicio.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.fechaFinal.name,
      label: CONST.fechaFinal.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value.nombre}
                size="small"
                color={value.id === 1 ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={async () => {
                  const data = pagosSuscripcionStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  await setActivoPagosSuscripcionAction(dispatch, data);
                  setOpenModalDelete(true);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  return (
    <Grid container>
      <LoadingWidget
        isLoading={pagosSuscripcionStore.loadingAll || loadingDelete}
        text={loadingDelete ? 'Eliminando registro...' : 'Cargando lista...'}
      />
      <Grid item md={12}>
        <MUIDataTable
          title={'Listado'}
          data={pagosSuscripcionStore.all}
          columns={columns}
          options={options}
        />
      </Grid>
      {pagosSuscripcionStore.activo ? (
        <ModalComponent
          id="modalDeletePagosSuscripcion"
          title={`Eliminar`}
          open={openModalDelete}
          maxWidth="sm"
          onClose={() => setOpenModalDelete(!openModalDelete)}
        >
          <Grid container spacing={1}>
            <Grid item md={12}>
              <Typography variant="body">
                ¿Seguro que quieres eliminar esta suscripción?
              </Typography>
              <br />
              <br />
              <Typography variant="body">
                <strong>Entidad</strong>:{' '}
                {pagosSuscripcionStore.activo.entidad.nombre}
                <br />
                <strong>Titular</strong>:{' '}
                {pagosSuscripcionStore.activo.titular.perfil.pnombre}{' '}
                {pagosSuscripcionStore.activo.titular.perfil.papellido}
              </Typography>
            </Grid>
            <Grid item md={12} align="right">
              {pagosSuscripcionStore.activo.totalEntidades > 0 ? null : (
                <Button
                  color="error"
                  variant="outlined"
                  onClick={async () => {
                    await _handleDeleteClick(pagosSuscripcionStore.activo.id);
                  }}
                  sx={{ mr: 2 }}
                >
                  ELIMINAR
                </Button>
              )}
              <Button
                sx={{ color: BLUE_COLOR }}
                onClick={() => setOpenModalDelete(false)}
              >
                CANCELAR
              </Button>
            </Grid>
          </Grid>
        </ModalComponent>
      ) : null}
    </Grid>
  );
};

export default ListadoPagosSuscripcion;
